module.exports = __webpack_public_path__ + "img/the-netherlands-colorectal-cancer-male.e06c5ca3.png";